import { render, staticRenderFns } from "./BeneficiaryPlanMargins.vue?vue&type=template&id=a188b768&scoped=true"
import script from "./BeneficiaryPlanMargins.vue?vue&type=script&lang=js"
export * from "./BeneficiaryPlanMargins.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryPlanMargins.vue?vue&type=style&index=0&id=a188b768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a188b768",
  null
  
)

export default component.exports